import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { MdEdit, MdDelete, MdDescription } from 'react-icons/lib/md';
import { modalStyle } from '../../constants';
import { withAuth } from '../../actions/';
import { fetchContracts, fetchContractorFieldInfo } from '../../actions/project_actions';
import { formatPhoneNumber, formatEmail } from '../../utils/'; 
import ContractorFieldInfoForm from './ContractorFieldInfoForm';

class ContractorFieldInfo extends Component {
  // static PropTypes = {
  //   permissions: PropTypes.object.isRequired,
  //   projectId: PropTypes.string.isRequired,
  //   contracts: PropTypes.array.isRequired,
  //   contractorFieldInfos: PropTypes.array.isRequired,
  //   fetchContracts: PropTypes.func.isRequired,
  //   fetchContractorFieldInfo: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);

    this.state = {
      infoTypes: [
          { id: 1, desc: 'Contractor/Principal Main Office' }, 
          { id: 10, desc: 'Consultant Main Office' }, 
          { id: 4, desc: 'Location Field Office Contact' }, 
        ],
      toDelete: null,
      isOpen: false,
      fieldInfo : this.getNewFieldInfo()
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleTelChange = this.handleTelChange.bind(this);
    this.handleTelAltChange = this.handleTelAltChange.bind(this);
    this.handleContractChange = this.handleContractChange.bind(this); 
    this.handleInfoTypeChange = this.handleInfoTypeChange.bind(this); 
    this.handleFaxChange = this.handleFaxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getNewFieldInfo() {
        return {
            id: -1,
            name: '',
            address: '', 
            email: '', 
            tel: '', 
            telAlternate: '',
            fax:'', 
            contractId: '', 
            type: '',
            createBy: '',
            createdDate: '',
            formValid: true
        }
    }

  UNSAFE_componentWillMount () {
    const { projectId, fetchContracts, fetchContractorFieldInfo } = this.props;
    fetchContracts(projectId);
    fetchContractorFieldInfo(projectId);
  }

  handleContractChange (option) {
    const contractId = option ? option.value : '';
    const fieldInfo = this.state.fieldInfo;
    fieldInfo.contractId = contractId;
    this.setState({ fieldInfo });
  }

  handleInfoTypeChange (option) {
    const infoTypeId = option ? option.value : '';
    const fieldInfo = this.state.fieldInfo;
    fieldInfo.type = infoTypeId;
    this.setState({ fieldInfo });
  }

   handleTelChange (e) {
    let tel = e.target.value;
    tel = tel.replace(/\D/g, '').substring(0, 10); 
    const fieldInfo = this.state.fieldInfo;
    fieldInfo.tel = tel;
    this.setState({ fieldInfo });
  }

  handleTelAltChange (e) {
    let telAlternate = e.target.value;
    telAlternate = telAlternate.replace(/\D/g, '').substring(0, 10); 
    const fieldInfo = this.state.fieldInfo;
    fieldInfo.telAlternate = telAlternate;
    this.setState({ fieldInfo });
  }

  handleFaxChange (e) {
    let fax = e.target.value;
    fax = fax.replace(/\D/g, '').substring(0, 10);
    const fieldInfo = this.state.fieldInfo;
    fieldInfo.fax = fax;
    this.setState({ fieldInfo });
  }

  handleChange (field) {
    const fieldInfo = this.state.fieldInfo;
    return (e) => {
        fieldInfo[field] = e.target.value;
        this.setState({ fieldInfo });
    }
  }


  onModalClose(fieldInfo,isOpen) {
    return (e) => {
        e.preventDefault();
        this.setState({ fieldInfo, isOpen: isOpen });
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    this.saveHandler();
    this.setState({ isOpen: false });
  }

  saveHandler() {
    const { projectId } = this.props;
    const {fieldInfo } = this.state;

    let method = 'post';
    let url = `projects/${projectId}/contractorsubentities`;
    if (fieldInfo.id > 0) {
      method = 'put';
      url = `${url}/${fieldInfo.id}`;
    }

    return this.makePutOrPostRequest(fieldInfo, method, url);
  }

  makePutOrPostRequest(fieldInfo, method, url) {
    const { projectId } = this.props;

    fieldInfo.projectId = projectId;

    withAuth(
      { method, url, data: fieldInfo },
      () => {
        this.props.fetchContractorFieldInfo(projectId);
      },
      this.errorHandler
    )
  }

  deleteContractSubEntity(fieldInfoId) {
      const projectId = this.props.projectId;
      const url = `/projects/${projectId}/contractorsubentities/${fieldInfoId}`;
      withAuth(
          { method: 'delete', url },
          () => {
              this.props.fetchContractorFieldInfo(projectId);
          },
        this.errorHandler
      );
  }

  renderRowButtons (row) {
    return (
      <td>
        <button onClick={this.onModalClose(Object.assign({},row), true)}>
        <span><MdEdit size={22} color='#8492a6'/></span>
        </button>
        <button onClick={() => this.deleteContractSubEntity(row.id)}>
        <span><MdDelete size={22} color='#8492a6'/></span>
        </button>
      </td>
    )
  }

  renderTable () {
    const { contractorFieldInfos } = this.props;
    const { roleModules } = this.props.permissions.editPrivileges;

    if (contractorFieldInfos.length === 0) {
      return <div>This project has no Contractor Field Info.</div>
    }

    const canEdit = roleModules !== null && roleModules.includes('Contractor Field Info') 
    ? true : false;

    return (
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Info Type</th>
              <th>Reg. #</th>
              <th>Address</th>
              <th>Phone</th>
              <th>Alternate Phone</th>
              <th>Email</th>
              <th>Fax</th>
               { canEdit ? <th>Actions</th> : null }
            </tr>
          </thead>
          <tbody>
            {contractorFieldInfos.map(row => {
            var filteredType  = this.state.infoTypes.filter( t=> t.id=== row.type);
            
            var typeDesc = (filteredType.length > 0) ? filteredType[0].desc : null;

              return (
                <tr key={row.id}>
                  <td>{typeDesc}</td>
                 <td> {row.contract!==null ? row.contract.regNumber: null } </td>
                  <td>{row.address}</td>
                  <td>{formatPhoneNumber(row.tel)}</td>
                  <td>{formatPhoneNumber(row.telAlternate)}</td>
                  <td>{formatEmail(row.email)}</td>
                  <td>{formatPhoneNumber(row.fax)}</td>
                  { canEdit ? this.renderRowButtons(row) : null }
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }


  render () {
    const { contractorFieldInfos } = this.props;
    const { roleModules } = this.props.permissions.editPrivileges;

    const canEdit = roleModules !== null && roleModules.includes('Contractor Field Info') 
    ? true : false;

    return (
      <div className="row-wide project-logs" id = "fieldInfo">
        <div className="col s12">
          <h4 className="bar-bottom">
          <span><MdDescription size={20} /></span> Contractor Field Info
          </h4>
        </div>
        
        <div className="col s12">
          {contractorFieldInfos.length
            ? this.renderTable(contractorFieldInfos)
            : <div>This project has no Contractor Field Info items entries yet.</div>}
        </div>
         { canEdit
            ? 
         <div className="section-buttons">
           
           <button className="btn-save" onClick={this.onModalClose(this.getNewFieldInfo(),true)}>
              Add
            </button>
      
          </div>
          : null }
                 <Modal
                    isOpen={this.state.isOpen}
                    style={modalStyle}
                    contentLabel="Contractor Field Info">
                    <h1>Contractor Field Info</h1>
                <ContractorFieldInfoForm
                    projectId={this.props.projectId}
                    onSave={this.saveHandler} 
                    contracts={this.props.contracts} 
                    infoTypes = {this.state.infoTypes} 
                    fieldInfo = {this.state.fieldInfo} 
                    handleInfoTypeChange= {this.handleInfoTypeChange}
                    handleChange = {this.handleChange}
                    handleContractChange = {this.handleContractChange}
                    handleFaxChange = {this.handleFaxChange}
                    handleTelChange = {this.handleTelChange} 
                    handleTelAltChange = {this.handleTelAltChange}
                    onSubmit = {this.handleSubmit}
                
                />
                <div className="modal-close" onClick={this.onModalClose(this.getNewFieldInfo(),false)}>
                    <span className="close"></span>
                </div>
            </Modal>


      </div>
    );
  }
}

ContractorFieldInfo.propTypes = {
  permissions: PropTypes.object.isRequired,
  projectId: PropTypes.string.isRequired,
  contracts: PropTypes.array.isRequired,
  contractorFieldInfos: PropTypes.array.isRequired,
  fetchContracts: PropTypes.func.isRequired,
  fetchContractorFieldInfo: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    contracts: state.projectsStore.contracts,
    contractorFieldInfos: state.projectsStore.contractorFieldInfos,
    permissions: state.projectsStore.permissions,
  };
}

export default connect(mapStateToProps, { fetchContracts, fetchContractorFieldInfo })(ContractorFieldInfo);